<template>
  <TariffNotificationModal
      ref="modalRef"
      title="В Finch появились пакеты 3, 6 и 12 месяцев"
      @button-click="onConfirm"
      @hidden="emit('hidden')"
      button-text="Подробнее"
      :max-width="450"
  >
    <template #default>
        <img
            class="packages-announcement-modal__image"
            src="/assets/images/tariff/packages-announcement.png"
            alt="Иллюстрация"
        />
        <p class="packages-announcement-modal__text mb-3">
            Теперь выбрать подходящий вариант стало ещё проще.
        </p>
        <div class="packages-announcement-modal__accent mb-3">
            <ul class="packages-announcement-modal__list">
                <li>Оплата сразу на 3, 6 или 12 месяцев.</li>
                <li>Чем больше срок — тем выгоднее стоимость.</li>
                <li>Или выбирайте отдельные функции с ежемесячной оплатой.</li>
            </ul>
        </div>
        <p class="packages-announcement-modal__text mb-0">
            Подключайте готовые пакеты или оплачивайте только те функции,
            которыми действительно пользуетесь.
        </p>
    </template>
  </TariffNotificationModal>
</template>

<script setup lang="ts">
// Модалка-анонс запуска пакетов на 3/6/12 месяцев (FINCH-2446).
// Иллюстрация лежит внутри default-слота, а не передаётся через imageUrl:
// шелл рендерит imageUrl колонкой слева, а по макету картинка идёт сверху по центру.
import { ref } from 'vue';
import TariffNotificationModal from '../TariffNotificationModal.vue';

const modalRef = ref<InstanceType<typeof TariffNotificationModal>>();

const emit = defineEmits<{
    (e: 'hidden'): void;
    (e: 'confirm'): void;
}>();

function onConfirm() {
    emit('confirm');
}

function showModal() {
    modalRef.value?.show();
}

function hideModal() {
    modalRef.value?.hide();
}

defineExpose({
    show: showModal,
    hide: hideModal,
});
</script>

<style lang="scss" scoped>
.packages-announcement-modal__image {
    display: block;
    width: 273px;
    max-width: 100%;
    height: auto;
    margin: 16px auto 24px;
}

.packages-announcement-modal__text {
    font-size: 14px;
}

.packages-announcement-modal__accent {
    color: #ffffff;
    background-color: #e763ae;
    border-radius: 8px;
    padding: 12px 16px;
}

.packages-announcement-modal__list {
    margin: 0;
    padding-left: 20px;
    font-size: 14px;
}
</style>
